import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PhcApp, PhcArticle } from "../../classes/phc-app/phc-app";
import { WpProvider } from "../../providers/wp/wp";
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { KioskServiceProvider } from '../../providers/kiosk-service/kiosk-service';

/**
 * Generated class for the ArticlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-article',
  templateUrl: 'article.html',
})
export class ArticlePage {

  articleId: number;
  article: PhcArticle;
  phcApp: PhcApp;
  listener;
  browser;

  constructor(
    private kioskService: KioskServiceProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    private wp: WpProvider,
    private iab: InAppBrowser
  ) {
    this.phcApp = wp.app;
    this.articleId = navParams.get('articleId');
    this.article = this.phcApp.getArticle(this.articleId);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArticlePage');
    (document.querySelector('.phc-article-content') as HTMLDivElement).addEventListener('click', this.processClick);
  }

  ionViewWillLeave() {
    (document.querySelector('.phc-article-content') as HTMLDivElement).removeEventListener('click', this.processClick);
  }


  processClick = ($event) => {
    console.log($event.target.href);
    if ($event.target.tagName === 'A' && $event.target.href && $event.target.href.indexOf('http') > -1) {
      $event.preventDefault();
      if (!this.kioskService.isKiosk) {
        this.browser = this.iab.create($event.target.href, '_blank');
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/article/article.ts